import DropdownTemplate from '../../html/components/dropdown.html'
import DropdownDividerTemplate from '../../html/components/dropdown-divider.html'
import DropdownActionTemplate from '../../html/components/dropdown-action.html'
import DropdownToggleTemplate from '../../html/components/dropdown-toggle.html'

import {inert} from '../shared/directives'
import Component from '../shared/component'
import Relation, {HasOne, HasMany, MemberOf} from '../shared/mixins/relation'
import {PopperMixin, PopperToggleMixin} from '../shared/mixins/popper'

import {Interactive, InteractiveMixin} from './interactive'
import {Leavable} from './leavable'

const dropdownToggle = Relation()
const dropdownActions = Relation()

export const Dropdown = Component('v-dropdown', {
  mixins: [
    HasMany(dropdownActions, 'actions'),
    MemberOf(dropdownToggle, 'toggle'),
    PopperMixin('toggle', {
      placement: 'bottom',
      shift: 'start'
    })
  ],
  template: DropdownTemplate,
  props: {
    fill: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    open () {
      const {toggle} = this

      if (toggle) {
        return toggle.open
      }

      return true
    }
  }
})

export const DropdownDivider = Component('v-dropdown-divider', {
  template: DropdownDividerTemplate
})

export const DropdownAction = Component('v-dropdown-action', {
  components: [
    Interactive
  ],
  mixins: [
    MemberOf(dropdownActions, 'dropdown'),
    InteractiveMixin
  ],
  directives: {
    inert
  },
  template: DropdownActionTemplate,
  methods: {
    hide () {
      const {dropdown} = this

      if (!dropdown) {
        return
      }

      const {toggle} = dropdown

      if (toggle) {
        return toggle.hide()
      }
    }
  }
})

export const DropdownToggle = Component('v-dropdown-toggle', {
  components: [
    Leavable
  ],
  mixins: [
    HasOne(dropdownToggle, 'dropdown'),
    PopperToggleMixin('dropdown')
  ],
  template: DropdownToggleTemplate,
  data () {
    return {
      open: false
    }
  },
  computed: {
    target () {
      const {dropdown} = this

      if (dropdown) {
        return dropdown.id
      }
    }
  },
  watch: {
    open () {
      if (!this.dropdown) {
        return
      }

      if (this.open) {
        this.pop()
      } else {
        this.unpop()
      }
    }
  },
  methods: {
    toggle () {
      if (this.open) {
        this.hide()
      } else {
        this.show()
      }
    },

    show () {
      if (!this.open) {
        this.open = true
      }
    },

    hide () {
      if (this.open) {
        this.open = false
      }
    }
  }
})

export const DropdownToggleMixin = {
  props: {
    dropdown: {
      type: Object,
      default: null
    }
  }
}
